import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { misc } from "app/themes/colors";

type ChartNotesStyleTabLabelProps = {
  label: string;
  isActive: boolean;
  count?: number;
};

export default function ChartNotesStyleTabLabel({
  label,
  isActive,
  count
}: ChartNotesStyleTabLabelProps) {
  return (
    <Stack direction="row" alignItems="center" gap={0.75}>
      <Typography
        variant="body2"
        className={!isActive ? "tabText" : undefined}
      >
        {label}
      </Typography>
      {count !== undefined && (
        <Chip
          label={count}
          size="small"
          sx={{
            height: 18,
            fontSize: "0.7rem",
            pointerEvents: "none",
            background: isActive ? undefined : misc.sunoGreen,
            color: isActive ? undefined : "white"
          }}
        />
      )}
    </Stack>
  );
}
